// Port of api/fuel/app/classes/filter/search/games/sorts/query/comment/count.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'comments',
	post: false,
	require: function(config, filter) { return sorted('comments', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('COUNT(DISTINCT(m.comment_id))', sortReverse('comments', filter), sortPriority('comments', filter))
	}
}
